<mat-sidenav-container>
  <mat-sidenav position="end"
               mode="push"
               [(opened)]="inner.opened"
               class="inner-sidebar max-w-full max-h-full">
    <button (click)="inner.opened.set(false)"
            class="btn btn-text btn-icon small ml-4 mt-2">
      <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
    </button>

    @for(list of items.inner.value(); track list) {
    <ul link-tree [items]="list" class="mt-2"></ul>
    }
  </mat-sidenav>
  <mat-sidenav-content>
    <ul link-tree [items]="items.outer" class="mt-4"></ul>
  </mat-sidenav-content>
</mat-sidenav-container>